var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "warning-a",
    d: "M11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 Z M11,20.4285714 C16.2072562,20.4285714 20.4285714,16.2072562 20.4285714,11 C20.4285714,5.79274379 16.2072562,1.57142857 11,1.57142857 C5.79274379,1.57142857 1.57142857,5.79274379 1.57142857,11 C1.57142857,16.2072562 5.79274379,20.4285714 11,20.4285714 Z M11,17.2857143 C10.132124,17.2857143 9.42857143,16.5821617 9.42857143,15.7142857 C9.42857143,14.8464097 10.132124,14.1428571 11,14.1428571 C11.867876,14.1428571 12.5714286,14.8464097 12.5714286,15.7142857 C12.5714286,16.5821617 11.867876,17.2857143 11,17.2857143 Z M10.2142857,4.71428571 L11.7857143,4.71428571 C12.2196469,4.71428571 12.5714286,5.06606198 12.5714286,5.5 C12.5714286,5.52445118 12.5702872,5.54888903 12.5714286,5.57366071 L11.9821429,11.859375 C11.9417655,12.2627485 11.6028339,12.5714286 11.1964286,12.5714286 L10.8526786,12.5714286 C10.4579436,12.5714286 10.1203707,12.2667947 10.0669643,11.859375 L9.42857143,5.57366071 C9.38836375,5.14871438 9.70231383,4.76279802 10.140625,4.71428571 C10.1606863,4.71566149 10.1875139,4.71428571 10.2142857,4.71428571 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "warning-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#warning-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FA8C16",
    mask: "url(#warning-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 -1 23)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4d7dd2fe.svg";
export { ForwardRef as ReactComponent };